import { forwardRef } from 'react';
import type { HTMLAttributes } from 'react';
import styles from './BottomBar.module.css';

const cx = (...classes: (string | undefined | false | null)[]) =>
  classes.filter(Boolean).join(' ');

export const LeftPanel = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(function LeftPanel({ className, ...props }, ref) {
  return (
    <div ref={ref} className={cx(styles.leftPanel, className)} {...props} />
  );
});

export const MidPanelPhone = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(function MidPanelPhone({ className, ...props }, ref) {
  return (
    <div ref={ref} className={cx(styles.midPanelPhone, className)} {...props} />
  );
});

export const MidPanel = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(function MidPanel({ className, ...props }, ref) {
  return (
    <div ref={ref} className={cx(styles.midPanel, className)} {...props} />
  );
});

export const RightPanel = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(function RightPanel({ className, ...props }, ref) {
  return (
    <div ref={ref} className={cx(styles.rightPanel, className)} {...props} />
  );
});
